// extracted by mini-css-extract-plugin
export var closeButton = "ShortsModal-module--closeButton--4686f";
export var closeIcon = "ShortsModal-module--closeIcon--1e742";
export var container = "ShortsModal-module--container--6cfbe";
export var current = "ShortsModal-module--current--b0e3e";
export var fadeInAnimation = "ShortsModal-module--fadeInAnimation--e34ae";
export var pagination = "ShortsModal-module--pagination--10b80";
export var paginationItem = "ShortsModal-module--paginationItem--d3ef3";